module.exports = __webpack_public_path__ + "img/pr-9.bf201557.png";